import { GET_QUEUE_POSITIONS, GET_QUEUE_POSITIONS_SUCCESS, GET_QUEUE_POSITIONS_ERROR } from './actionTypes';

const initialState = {
  errorGetQueuePositions: '',
  loadingGetQueuePositions: false,
  queue_positions: null,
  successGetQueuePositions: '',
};

const getQueuePositions = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUEUE_POSITIONS:
      state = {
        ...state,
        loadingGetQueuePositions: true,
      };
      break;
    case GET_QUEUE_POSITIONS_SUCCESS:
      state = {
        ...state,
        loadingGetQueuePositions: false,
        queue_positions: action.payload.queue_positions,
        successGetQueuePositions: action.payload.message,
      };
      break;
    case GET_QUEUE_POSITIONS_ERROR:
      state = { ...state, errorGetQueuePositions: action.payload, loadingGetQueuePositions: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getQueuePositions;
